export type OnboardingAgentMessagePart =
  | { type: 'text'; value: string; key: string }
  | { type: 'asset'; name: string; key: string };

/**
 * `<File name.jpg>` in onboarding copy is an asset chip. Angle brackets stay out of the wire
 * format (`@[pill:<id>]`) because these replies have stills, not clip ids.
 */
const ASSET_NAME_SOURCE = '<([^<>]+)>';

export const splitOnboardingAgentAssetNames = (message: string): OnboardingAgentMessagePart[] => {
  const parts: OnboardingAgentMessagePart[] = [];
  const pattern = new RegExp(ASSET_NAME_SOURCE, 'g');
  let lastIndex = 0;

  for (const match of message.matchAll(pattern)) {
    const start = match.index;

    if (start > lastIndex) {
      parts.push({
        type: 'text',
        value: message.slice(lastIndex, start),
        key: `text-${lastIndex}-${start}`,
      });
    }

    parts.push({ type: 'asset', name: match[1], key: `asset-${start}-${match[1]}` });
    lastIndex = start + match[0].length;
  }

  if (lastIndex < message.length) {
    parts.push({
      type: 'text',
      value: message.slice(lastIndex),
      key: `text-${lastIndex}-end`,
    });
  }

  return parts;
};
